import { useMemo } from "react";
import { gql, useQuery } from "@apollo/client";
import { useParams } from "react-router";

import { GET_ABBVIE_PRO_FORM_DATA, GET_ALLERGAN_PRO_FORM_DATA } from "./query";
import { SectionTitle, CmpTable } from "../shared";
import SubComponent from "./SubComponent";
import { ROUTE_AUTH_APP_LIST, exportToExcel } from "../../utils";
import { toast } from "react-toastify";

const FormInfo = ({ appName }) => {
    const { id } = useParams();

    const QUERY =
        (appName === ROUTE_AUTH_APP_LIST.ABBVIEPRO && GET_ABBVIE_PRO_FORM_DATA) ||
        (appName === ROUTE_AUTH_APP_LIST.ALLERGANPRO && GET_ALLERGAN_PRO_FORM_DATA);

    const DATAPATH =
        (appName === ROUTE_AUTH_APP_LIST.ABBVIEPRO && "abbvieProSystemSettingByFormKey") ||
        (appName === ROUTE_AUTH_APP_LIST.ALLERGANPRO && "allerganProSystemSettingByFormKey");
    const subDATAPATH =
        (appName === ROUTE_AUTH_APP_LIST.ABBVIEPRO && "abbvieProFormDataStoresByFormKey") ||
        (appName === ROUTE_AUTH_APP_LIST.ALLERGANPRO && "allerganProFormDataStoresByFormKey");

    const { loading, data } = useQuery(gql(QUERY), {
        variables: { formKey: id },
    });

    const title = data?.[DATAPATH]?.formText;
    const FormDataStores = data?.[DATAPATH]?.[subDATAPATH]?.nodes;

    const excelExportAll = () => {
        if (!loading && FormDataStores && FormDataStores.length > 0) {
            const excelData = [];
            FormDataStores.forEach((item) => {
                const obj = {};
                const _formData = JSON.parse(item.formData);

                for (const key in _formData) {
                    if (Object.prototype.hasOwnProperty.call(_formData, key)) {
                        const titleCaseKey = key
                            .toLowerCase()
                            .split(" ")
                            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                            .join(" ");
                        obj[titleCaseKey] = _formData[key];
                    }
                }

                excelData.push(obj);
            });
            exportToExcel(excelData, title);
        } else {
            toast.error("No form data available!!!");
        }
    };

    const columns = useMemo(() => [
        {
            accessorKey: "eventId",
            header: "Event ID",
            enableColumnFilter: false,
        },
        {
            accessorKey: "iccId",
            header: "ICC ID",
            enableColumnFilter: false,
        },
        {
            accessorKey: "createdAt",
            header: "Create Date",
            cell: (cell) => (cell.getValue() ? new Date(cell.getValue()).toUTCString() : ""),
            enableColumnFilter: false,
        },
    ]);

    const renderSubComponent = (data) => {
        return <SubComponent data={data.row.original} appName={appName} />;
    };

    return (
        <>
            <SectionTitle title={title && title.split("-").join(" ")} backUrl={`/${appName}/forms`}>
                <button className="btn btn-outline-primary" type="button" onClick={excelExportAll}>
                    Download Data
                </button>
            </SectionTitle>
            {!loading && (
                <CmpTable
                    QUERY={QUERY}
                    headers={columns}
                    dataPath={`${DATAPATH}.${subDATAPATH}`}
                    variables={{ formKey: id }}
                    renderSubComponent={renderSubComponent}
                />
            )}
        </>
    );
};

export default FormInfo;
